export default {"src":"/_next/static/media/white_location.f6b5be19.svg","height":26,"width":20,"blurWidth":0,"blurHeight":0};